import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TipoServicioService {

  private apiUrl = `${environment.apiUrl}/tipo-servicio`

  constructor(private http: HttpClient) { }

  findAll(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}`);
  }
  findById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }
  updateTipoServicio(id: number, tipoServicio: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, tipoServicio);
  }
  createTipoServicio(tipoServicio: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, tipoServicio);
  }
  deleteTipoServicio(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
